import { Separator } from '@ais-ui/ui-core';
import { VectorTileForm } from './VectorTileForm';
import { useLocalization } from '@ais-ui/locale-management';

export function SettingsVectorTilesPage() {
  const { messages } = useLocalization();
  return (
    <div className="space-y-6 w-full">
      <div>
        <h3 className="text-2xl font-medium">
          {messages.settingsVectorTilesTitle}
        </h3>
        <p className="text-sm text-muted-foreground">
          {messages.settingsVectorTilesSubtitle}
        </p>
      </div>
      <Separator className="w-full" />
      <VectorTileForm />
    </div>
  );
}
